module.exports = __webpack_public_path__ + "img/audio-permission-setting-chrome.0b3b612b.gif";